import { Link, useNavigate } from "react-router-dom";
import BlogSection from "../components/blog-section";
import Logo from "../logo-removebg-preview.png";
import { useAuth } from "../contexts/auth-context";
import { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@nextui-org/react";

export default function IndexPage() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();

  const [{ isAuthenticated, user, hasTemporaryToken }] = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('phone');


  const scrollToBlog = () => {
    const blogSection = document.getElementById('blog-section');
    if (blogSection) {
      blogSection.scrollIntoView({ behavior: 'smooth' });
    }
    setIsModalOpen(false);
  };

  const handleCreateDecision = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      setIsModalOpen(true);
    }
  };

  const handleOpenModal = (productType) => {
    setSelectedProduct(productType);
    onOpen();
  };

  return (
    <div>
      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          ></div>
        </div>
        <div className="mx-auto max-w-2xl py-8 sm:py-8 lg:py-8 z-10">
          <div className="hidden sm:mb-8 sm:flex sm:justify-center">
            {/* <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
              کاربردهای گزینه محدود به یک مورد خاص نیست{" "}
              <a
                href="https://blog.gozineh-app.com"
                className="font-semibold text-indigo-600"
              >
                <span className="absolute inset-0" aria-hidden="true"></span>
                اطلاعات بیشتر <span aria-hidden="true">→</span>
              </a>
            </div> */}
          </div>
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
              گزینه: دستیار تصمیم‌گیر
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              هدف گزینه تسهیل فرآیند تصمیم گیری و کمک به انتخاب درست است. گزینه
              یک نرم افزار محاسباتی است که با استفاده از یک الگوریتم ابداعی و با
              پرسیدن چند سوال به صورت مقایسه های زوجی ترجیحات افراد و میزان
              اهمیت آنها را مشخص می کند.
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/problem/type"
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                onClick={handleCreateDecision}
              >
                ایجاد تصمیم جدید
              </Link>
              <a
                href="http://gozinehapp.com/help"
                className="text-sm font-semibold leading-6 text-gray-900"
              >
                بیشتر بدانید <span aria-hidden="true">←</span>
              </a>
            </div>
          </div>
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          ></div>
        </div>
      </div>
      <div class="mx-auto max-w-7xl px-6 lg:px-8 mt-16"><div class="mx-auto text-center"><h2 class="text-xl font-bold tracking-tight text-gray-900 sm:text-3xl">خرید هوشمندانه</h2><p class="mt-2 text-lg leading-8 text-gray-600">از این بخش می‌توانید از گزینه‌های موجود در بازار استفاده کنید</p></div></div>

      <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-16">
        <div class="w-full grid lg:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-20 max-w-4xl mx-auto">
          <div class="flex flex-col items-center justify-center text-center py-5 px-4 rounded border-2 border-pink-300 bg-gradient-to-r from-rose-100 to-teal-100 text-black">
            <p class="text-2xl font-bold mb-4 drop-shadow-xl">
              خرید تلفن همراه
            </p>
            <button
              class="px-6 py-2 border border-gray-300 rounded-lg bg-white text-primary font-semibold hover:bg-gray-100 transition"
              type="button"
              onClick={() => handleOpenModal('phone')}
            >
              شروع کنید <span aria-hidden="true">→</span>
            </button>
          </div>

          <div class="flex flex-col items-center justify-center text-center py-5 px-4 rounded border-2 border-pink-300 bg-gradient-to-r from-rose-100 to-teal-100 text-black">
            <p class="text-2xl font-bold mb-4 drop-shadow-xl">خرید لپتاپ</p>
            <button
              class="px-6 py-2 border border-gray-300 rounded-lg bg-white text-primary font-semibold hover:bg-gray-100 transition"
              type="button"
              onClick={() => handleOpenModal('laptop')}
            >
              شروع کنید <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-16">
        <div className="mx-auto text-center">
          <h2 className="text-xl font-bold tracking-tight text-gray-900 sm:text-3xl">
            قالب‌های تصمیم گیری آماده
          </h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            در این بخش گزینه به شما کمک می کند که گزینه های مورد نظر خود راحت تر
            پیدا کنید
          </p>
        </div>
      </div>
      <div id="blog-section">
        <BlogSection
          cat="public"
          title="تصمیمات شخصی"
          subtitle="از این بخش می‌توانید از قالب‌های تصمیم گیری آماده از پیش تعیین شده استفاده کنید."
        />
        <BlogSection
          cat="organization"
          title="تصمیمات سازمانی"
          subtitle="از این بخش می‌توانید از تصمیم‌های سازمانی استفاده کنید."
        />
      </div>

      {/* Testimonials Section */}
      {/* <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-xl text-center">
            <h2 className="text-lg font-semibold leading-8 tracking-tight text-indigo-600">نظرات کاربران</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              کاربران ما درباره گزینه چه می‌گویند
            </p>
          </div>
          <div className="mx-auto mt-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {[
                {
                  content: "گزینه به من کمک کرد تا بهترین انتخاب را برای خرید لپتاپ داشته باشم. فرآیند تصمیم‌گیری بسیار ساده و کاربردی بود.",
                  author: "علی محمدی",
                  role: "کارشناس فناوری اطلاعات",
                  imageUrl: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                },
                {
                  content: "به عنوان مدیر یک شرکت، استفاده از گزینه برای تصمیم‌گیری‌های سازمانی بسیار مفید بوده است. این ابزار به ما کمک می‌کند تا انتخاب‌های منطقی‌تری داشته باشیم.",
                  author: "مریم احمدی",
                  role: "مدیر عامل",
                  imageUrl: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                },
                {
                  content: "سادگی و کارایی گزینه باعث شده که برای تصمیم‌گیری‌های روزمره هم از آن استفاده کنم. واقعاً یک ابزار کاربردی است.",
                  author: "رضا حسینی",
                  role: "کارآفرین",
                  imageUrl: "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                },
              ].map((testimonial) => (
                <div key={testimonial.author} className="flex flex-col h-full">
                  <div className="flex flex-col h-full rounded-2xl bg-gray-50 p-8 shadow-sm ring-1 ring-gray-900/5">
                    <div className="flex flex-col h-full">
                      <div className="inline-flex items-center justify-center rounded-xl bg-indigo-500 p-3 shadow-lg w-12 h-12">
                        <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.926 1.926 0 011.037-.493 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                        </svg>
                      </div>
                      <blockquote className="mt-6 flex-grow">
                        <p className="text-lg leading-8 text-gray-900">{testimonial.content}</p>
                      </blockquote>
                      <div className="mt-8 flex items-center gap-x-4">
                        <img className="h-12 w-12 rounded-full bg-gray-50 ring-1 ring-gray-900/5" src={testimonial.imageUrl} alt="" />
                        <div>
                          <div className="font-semibold text-gray-900">{testimonial.author}</div>
                          <div className="text-sm leading-6 text-gray-600">{testimonial.role}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div> */}

      {/* Team Section */}
      {/* <div className="bg-gray-50 py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">تیم ما</h2>
            <p className="mt-2 text-lg leading-8 text-gray-600">
              با تیمی متخصص و با تجربه در زمینه تصمیم‌گیری و توسعه نرم‌افزار
            </p>
          </div>
          <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:mt-20 sm:grid-cols-2 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {[
              {
                name: "دکتر محمد رضایی",
                role: "بنیانگذار و مدیر عامل",
                imageUrl: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                bio: "دکترای مهندسی صنایع با بیش از ۱۵ سال تجربه در زمینه تصمیم‌گیری چند معیاره",
              },
              {
                name: "سارا احمدی",
                role: "مدیر محصول",
                imageUrl: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                bio: "کارشناس ارشد مدیریت فناوری اطلاعات با تجربه در توسعه محصولات دیجیتال",
              },
              {
                name: "علی محمدی",
                role: "توسعه‌دهنده ارشد",
                imageUrl: "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                bio: "کارشناس ارشد مهندسی نرم‌افزار با تخصص در توسعه اپلیکیشن‌های وب",
              },
            ].map((person) => (
              <div key={person.name} className="flex flex-col items-center">
                <img className="aspect-[3/2] w-full rounded-2xl object-cover sm:w-96" src={person.imageUrl} alt="" />
                <h3 className="mt-6 text-lg font-semibold leading-8 text-gray-900">{person.name}</h3>
                <p className="text-base leading-7 text-indigo-600">{person.role}</p>
                <p className="mt-4 text-center text-sm leading-6 text-gray-600">{person.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <footer className="bg-slate-50" aria-labelledby="footer-heading">
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="mx-auto max-w-md px-6 py-6 sm:max-w-7xl lg:px-8 lg:py-16">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="xl:col-span-1">
              <img className="h-10" src={Logo} alt="Company name" />
              <p className="text-base text-slate-500">
                دستیار هوشمند تصمیم‌گیری
              </p>
              <div className="flex space-x-6"></div>
            </div>
            <div className="mt-12 grid">
              <p className="text-base text-slate-400 xl:text-center">
                &copy; 2024 دستیار تصمیم‌گیر
              </p>
            </div>
          </div>
        </div>
      </footer>

      <Modal size={"full"} isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                {selectedProduct === 'laptop' ? 'خرید لپتاپ' : 'خرید گوشی'}
              </ModalHeader>
              <ModalBody>
                <div className="w-full h-full flex md:flex-row flex-col gap-20 justify-center items-center text-center">
                  <div className="relative text-center py-12 px-16 rounded border-2 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 bg-green-200 text-black">
                    <p className="text-lg font-bold mb-4 drop-shadow-xl">
                      سلیقه‌ام را می‌دانم
                    </p>
                    <Button
                      color="primary"
                      variant="faded"
                      onPress={() =>
                        navigate(
                          selectedProduct === 'laptop'
                            ? `/problem/create?template_id=${process.env.REACT_APP_LAPTOP_SAW_TEMPLATE_UID}`
                            : `/problem/create?template_id=${process.env.REACT_APP_PHONE_SAW_TEMPLATE_UID}`
                        )
                      }
                    >
                      شروع کنید <span aria-hidden="true">→</span>
                    </Button>
                    <div className="absolute left-4 top-4">
                      <Popover placement="left" color="warning">
                        <PopoverTrigger>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                            />
                          </svg>
                        </PopoverTrigger>
                        <PopoverContent>
                          <div className="px-1 py-2">
                            <div className="text-small font-bold">
                              یعنی شما دقیقا می دانید که چه معیارهایی برای خرید
                              موبایل برایتان مهم است. با انتخاب این گزینه به
                              صفحه ای هدایت می شوید که در آن وزن معیارها را مشخص
                              می کنید.
                            </div>
                            {/* <div className="text-tiny">This is the popover content</div> */}
                          </div>
                        </PopoverContent>
                      </Popover>
                    </div>
                  </div>
                  <div className="relative text-center py-12 px-16 rounded border-2 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 bg-green-200 text-black">
                    <p className="text-lg font-bold mb-4 drop-shadow-xl">
                      سلیقه‌ام را نمی‌دانم
                    </p>
                    <Button
                      color="primary"
                      variant="faded"
                      onPress={() =>
                        navigate(
                          selectedProduct === 'laptop'
                            ? `/problem/create?template_id=${process.env.REACT_APP_LAPTOP_NORMAL_TEMPLATE_UID}`
                            : `/problem/create?template_id=${process.env.REACT_APP_PHONE_NORMAL_TEMPLATE_UID}`
                        )
                      }
                    >
                      شروع کنید <span aria-hidden="true">→</span>
                    </Button>
                    <div className="absolute left-4 top-4">
                      <Popover placement="left" color="warning">
                        <PopoverTrigger>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                            />
                          </svg>
                        </PopoverTrigger>
                        <PopoverContent>
                          <div className="px-1 py-2">
                            <div className="text-small font-bold">
                              یعنی شما دقیقا نمی دانید که چه معیارهایی برای خرید
                              موبایل برایتان مهم است. با انتخاب این گزینه به
                              صفحه ای هدایت می شوید که با پاسخ به سوالاتی سلیقه
                              تان مشخص می شود.
                            </div>
                            {/* <div className="text-tiny">This is the popover content</div> */}
                          </div>
                        </PopoverContent>
                      </Popover>
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  بازگشت
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>

      {!hasTemporaryToken && isAuthenticated && user && !user.is_pro && (
        <div className="fixed bottom-0 left-0 w-full h-[50px] bg-white/10 backdrop-blur-md border-t border-gray-200 text-center flex items-center justify-center">
          <div className="flex items-center">
            <div className="ml-3">
              <span className="text-gray-800 font-medium">عضو عادی</span>
            </div>
            <div>
              <a
                className="text-sm font-bold text-blue-600 hover:text-blue-800"
                href="/premium"
              >
                عضویت ویژه
              </a>
            </div>
          </div>
        </div>
      )}

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalContent>
          <ModalHeader className="flex flex-col gap-1">
            ایجاد تصمیم جدید
          </ModalHeader>
          <ModalBody>
            <p>
              برای ایجاد تصمیم جدید، لطفاً وارد حساب کاربری خود شوید یا از تصمیم‌های از پیش تعریف شده استفاده کنید.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" variant="light" onPress={() => setIsModalOpen(false)}>
              انصراف
            </Button>
            <Button color="primary" onPress={() => window.location.href = '/login'}>
              ورود به حساب کاربری
            </Button>
            <Button color="secondary" onPress={scrollToBlog}>
              مشاهده تصمیم‌های آماده
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      

    </div>
  );
}
